import functions from "./functions.js";

const range = {
    $slider: null,

    init() {

        range.$slider = $('.custom-range');
        range.getSliderValue();

        range.$slider.on('input', e => {
            range.getSliderValue();
        });

    },
    getSliderValue() {
        $('.price-range').text(functions.formatMoney(range.$slider.val(), 2, ',', '.') + ' €');
    }
}

$(() => {
    range.init();
});
